import { t } from "i18next";

export interface Modality {
    id: number;
    name: string;
    description: string;
    gender: string;
    created_by: number;
    created_at: Date;
    changed_by: number;
    changed_at: Date;
}

export const emptyModality: Modality = {
    id: 0,
    name: '',
    description: '',
    gender: '',
    created_by: 0,
    created_at: new Date(),
    changed_by: 0,
    changed_at: new Date()
}

export const genderOptions = [
    {
        value: 'M',
        label: "Men"
    },
    {
        value: 'H',
        label: "Women"
    },
    {
        value: 'X',
        label: "Mixt"
    }
]